export const LANGUAGE_STORAGE_KEY = 'lang';
export const DEFAULT_LANGUAGE = 'en';

export const SUPPORTED_LANGUAGE_CODES = [
  'ru',
  'en',
  'vi',
  'es',
  'kk',
  'uz',
  'ky',
  'az',
  'pt',
  'fr',
  'tr',
  'de',
] as const;

export type TSupportedLanguage = typeof SUPPORTED_LANGUAGE_CODES[number];

interface ILanguageStorage {
  getItem: (key: string) => string | null;
  setItem: (key: string, value: string) => void;
}

const isSupportedLanguage = (value: string): value is TSupportedLanguage =>
  SUPPORTED_LANGUAGE_CODES.some((language) => language === value);

const getLanguageCode = (locale: string): string =>
  locale.trim().toLowerCase().split(/[-_]/)[0];

export const detectPreferredLanguage = (
  browserLanguages: readonly string[]
): TSupportedLanguage => {
  for (const locale of browserLanguages) {
    const language = getLanguageCode(locale);

    if (isSupportedLanguage(language)) return language;
  }

  return DEFAULT_LANGUAGE;
};

export const initializeLanguagePreference = (
  storage: ILanguageStorage,
  browserLanguages: readonly string[]
): TSupportedLanguage => {
  const savedLanguage = storage.getItem(LANGUAGE_STORAGE_KEY);

  if (savedLanguage && isSupportedLanguage(savedLanguage)) {
    return savedLanguage;
  }

  const language = detectPreferredLanguage(browserLanguages);
  storage.setItem(LANGUAGE_STORAGE_KEY, language);

  return language;
};
